<template>
  <div class="administration-create-news-wrapper">
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="isLoading" key="isLoadingAnimation">
        <img src="/static/img/admin/loading.svg" alt="Loading">
      </div>
      <div class="administration-create-news" v-else key="createNewsForm">
          <div class="administration-create-news-header">
            <h2 v-if="isEditing">Редактирай новина</h2>
            <h2 v-else>Създай новина</h2>
            <div>
              <a class="administration-news-close" @click="closeModal()">Отказ</a>
              <button class="administration-news-form-submit" @click="postNews()" :disabled="!isValid()">
                <span v-if="!isEditing">Създай</span>
                <span v-else>Запази</span>
              </button>
            </div>
          </div>
          <form class="administration-news-form" enctype="multipart/form-data">
              <div v-if="!isEditing || (isEditing && !newsObject.cover)">
                <label for="cover" class="upload-file">
                  <div class="upload-file-left">
                    <img src="/static/img/careers/application_form/upload.png" alt="Upload">
                    <div class="upload-file-left-texts">
                      <p>Основна снимка*</p>
                      <span>Файл</span>
                    </div>
                  </div>
                  <div class="upload-file-right">
                    <p v-if="!selectedMainImagePreview" >Избери</p>
                    <div v-else :style="{ backgroundImage: `url(${selectedMainImagePreview})` }" class="upload-preview"></div>
                    <svg class="folder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.73 59.75"><title>Избери</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M69.7,24.89h9L61.3,59.75H0V10H26.33l10-10H69.7ZM5,14.94V49.21L17.15,24.89H64.73V5H38.39l-10,10ZM58.19,54.77l12.45-24.9H20.23L7.74,54.77Z"/></g></g></svg>
                  </div>
                </label>
                <input class="input-hide" type="file" id="cover" ref="cover" @change="handleFileUpload()">
              </div>
              <!-- COVER PREVIEW EDITING MODE -->
              <div class="news-images-preview" v-if="isEditing && newsObject.cover">
                <div class="upload-file-left">
                  <img src="/static/img/careers/application_form/upload.png" alt="Upload">
                  <div class="upload-file-left-texts">
                    <p>Основна снимка*</p>
                    <span>Файл</span>
                  </div>
                </div>
                <div class="upload-file-right">
                  <div :style="{ backgroundImage: `url(https://www.alcomet.eu/uploads/news/${newsObject.cover})` }" class="upload-preview"></div>
                  <span class="delete" @click="removeCover()">
                      <svg aria-hidden="true" data-prefix="fas" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14 trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"></path></svg>
                  </span>
                </div>
              </div>
              <!-- GALLERY INPUT -->
              <div class="gallery-input-wrapper" v-if="!isEditing || (isEditing && !newsObject.gallery.length)">
                <label for="gallery" class="upload-file" :class="{ 'upload-gallery' : selectedFiles.length}">
                  <div class="upload-file-left">
                    <img src="/static/img/careers/application_form/upload.png" alt="Upload">
                    <div class="upload-file-left-texts">
                      <p>Галерия (до 10 снимки)</p>
                      <span>Файлове</span>
                    </div>
                  </div>
                  <div class="upload-file-right">
                    <p v-if="!selectedFiles.length">Избери</p>
                    <div v-else class="gallery-files-preview">
                      <div v-for="(file, index) in selectedFiles" :key="'galleryFile-' + index" :style="{ backgroundImage: `url(${file})` }" class="upload-preview"></div>
                    </div>
                    <svg class="folder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.73 59.75"><title>Избери</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M69.7,24.89h9L61.3,59.75H0V10H26.33l10-10H69.7ZM5,14.94V49.21L17.15,24.89H64.73V5H38.39l-10,10ZM58.19,54.77l12.45-24.9H20.23L7.74,54.77Z"/></g></g></svg>
                  </div>
                </label>
                <input class="input-hide" type="file" id="gallery" ref="gallery" @change="handleGalleryUpload()" multiple>
              </div>
              <!-- GALLERY PREVIEW EDITING MODE -->
              <div class="news-images-preview" v-if="isEditing && newsObject.gallery.length">
                <div class="upload-file-left">
                  <img src="/static/img/careers/application_form/upload.png" alt="Upload">
                  <div class="upload-file-left-texts">
                    <p>Галерия (до 10 снимки)</p>
                    <span>Файлове</span>
                  </div>
                </div>
                <div class="upload-file-right">
                  <div class="gallery-files-preview">
                    <div v-for="(file, index) in newsObject.gallery" :key="'galleryFile-' + index" :style="{ backgroundImage: `url(https://www.alcomet.eu/uploads/news/${file})` }" class="upload-preview"></div>
                  </div>
                  <span class="delete" @click="removeGallery()">
                      <svg aria-hidden="true" data-prefix="fas" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14 trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"></path></svg>
                  </span>
                </div>
              </div>
              <div class="news-content-wrapper">
                <div class="news-content-header">
                  <div class="news-content-toggle-lang-wrapper">
                    <span class="news-content-toggle-lang" :class="{ 'news-content-toggle-lang-active' : selectedLanguage === 'bg' }" @click="selectedLanguage = 'bg'">BG</span>
                    <span class="news-content-toggle-lang" :class="{ 'news-content-toggle-lang-active' : selectedLanguage === 'en' }" @click="selectedLanguage = 'en'">EN</span>
                    <span class="news-content-toggle-lang" :class="{ 'news-content-toggle-lang-active' : selectedLanguage === 'de' }" @click="selectedLanguage = 'de'">DE</span>
                    <span class="news-content-toggle-lang" :class="{ 'news-content-toggle-lang-active' : selectedLanguage === 'it' }" @click="selectedLanguage = 'it'">IT</span>
                  </div>
                  <div class="news-type">
                  <p>Тип новина:</p>
                    <div>
                      <span>
                        <input type="radio" name="isMediaNews" value="false" id="isMediaNewsFalse" v-model="newsObject.isMediaNews">
                        <label for="isMediaNewsFalse">Новина</label>
                      </span>
                      <span>
                        <input type="radio" name="isMediaNews" value="true" id="isMediaNewsTrue" v-model="newsObject.isMediaNews">
                        <label for="isMediaNewsTrue">Медиите за нас</label>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="news-content">
                  <div class="news-input-wrapper news-input-wrapper-row">
                     <div class="news-input-mini-wrapper">
                      <label>Дата на новината</label>
                      <input class="administration-news-form-input date-input" type="text"
                        :value="newsObject.date | formatDate" placeholder="ДД-ММ-ГГГГ"
                        @change="createNewDateFromString" @keyup="formatDate">
                    </div>
                    <div class="news-input-mini-wrapper">
                      <label>Адрес на новината (еднакъв за всички езици)*</label>
                      <div class="news-url-input">
                      <span>alcomet.eu/news/</span>
                      <input class="administration-news-form-input" type="text"
                        v-model="newsObject.url"
                        @keyup="formatUrl(), isUrlUnique()"
                        :class="{ 'not-valid' : (!isUrlValid && newsObject.url.length > 0) }"
                        :disabled="isEditing">
                      </div>
                    </div>
                  </div>
                  <!-- TITLES -->
                  <!-- BG TITLE -->
                  <div class="news-input-wrapper" v-if="selectedLanguage === 'bg'">
                    <span class="title-counter"
                      :class="{ 'title-counter-invalid': (70 - newsObject.content.bg.title.length) < 0}">
                      {{70 - newsObject.content.bg.title.length}}</span>
                    <label>(BG) Заглавие*</label>
                    <input class="administration-news-form-input" type="text" v-model="newsObject.content.bg.title">
                  </div>
                  <!-- EN TITLE -->
                  <div class="news-input-wrapper" v-if="selectedLanguage === 'en'">
                    <span class="title-counter"
                      :class="{ 'title-counter-invalid': (70 - newsObject.content.en.title.length) < 0}">
                      {{70 - newsObject.content.en.title.length}}</span>
                    <label>(EN) Заглавие*</label>
                    <input class="administration-news-form-input" type="text" v-model="newsObject.content.en.title">
                  </div>
                  <!-- DE TITLE -->
                  <div class="news-input-wrapper" v-if="selectedLanguage === 'de'">
                    <span class="title-counter"
                      :class="{ 'title-counter-invalid': (70 - newsObject.content.de.title.length) < 0}">
                      {{70 - newsObject.content.de.title.length}}</span>
                    <label>(DE) Заглавие*</label>
                    <input class="administration-news-form-input" type="text" v-model="newsObject.content.de.title">
                  </div>
                  <!-- IT TITLE -->
                  <div class="news-input-wrapper" v-if="selectedLanguage === 'it'">
                    <span class="title-counter"
                      :class="{ 'title-counter-invalid': (70 - newsObject.content.it.title.length) < 0}">
                      {{70 - newsObject.content.it.title.length}}</span>
                    <label>(IT) Заглавие*</label>
                    <input class="administration-news-form-input" type="text" v-model="newsObject.content.it.title">
                  </div>
                  <!-- BG CONTENT ONE -->
                  <!-- <div class="news-input-wrapper" v-show="selectedLanguage === 'bg'">
                    <label>(BG) Текст на новината преди галерията</label>
                    <div class="quill-editor-wrapper">
                      <app-quill-editor v-model="newsObject.content.bg.contentOne"></app-quill-editor>
                    </div>
                  </div> -->
                  <div class="news-input-wrapper" v-if="(this.isEditing && this.isNewsLoaded) || !this.isEditing">
                    <label v-show="selectedLanguage === 'bg'">(BG) Текст на новината преди галерията</label>
                    <label v-show="selectedLanguage === 'en'">(EN) Текст на новината преди галерията</label>
                    <label v-show="selectedLanguage === 'de'">(IT) Текст на новината преди галерията</label>
                    <label v-show="selectedLanguage === 'it'">(DE) Текст на новината преди галерията</label>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'bg'">
                      <app-quill-editor v-model="newsObject.content.bg.contentOne"></app-quill-editor>
                    </div>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'en'">
                      <app-quill-editor v-model="newsObject.content.en.contentOne"></app-quill-editor>
                    </div>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'de'">
                      <app-quill-editor v-model="newsObject.content.de.contentOne"></app-quill-editor>
                    </div>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'it'">
                      <app-quill-editor v-model="newsObject.content.it.contentOne"></app-quill-editor>
                    </div>
                  </div>
                  <p class="gallery-position-text">- Тук ще се намира галерията -</p>
                  <!-- BG CONTENT TWO -->
                  <div class="news-input-wrapper" v-if="(this.isEditing && this.isNewsLoaded) || !this.isEditing">
                    <label v-show="selectedLanguage === 'bg'">(BG) Текст на новината след галерията</label>
                    <label v-show="selectedLanguage === 'en'">(EN) Текст на новината след галерията</label>
                    <label v-show="selectedLanguage === 'de'">(IT) Текст на новината след галерията</label>
                    <label v-show="selectedLanguage === 'it'">(DE) Текст на новината след галерията</label>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'bg'">
                      <app-quill-editor v-model="newsObject.content.bg.contentTwo"></app-quill-editor>
                    </div>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'en'">
                      <app-quill-editor v-model="newsObject.content.en.contentTwo"></app-quill-editor>
                    </div>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'de'">
                      <app-quill-editor v-model="newsObject.content.de.contentTwo"></app-quill-editor>
                    </div>
                    <div class="quill-editor-wrapper" v-show="selectedLanguage === 'it'">
                      <app-quill-editor v-model="newsObject.content.it.contentTwo"></app-quill-editor>
                    </div>
                  </div>
                </div>
              </div>
          </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Editor from "../shared/Editor";
export default {
  components: {
    appQuillEditor: Editor
  },
  props: ["isMedia", "isEditing", "url"],
  data() {
    return {
      isSecondEditorAdded: false,
      isGalleryAdded: false,
      newsObject: {
        url: "",
        content: {
          bg: {
            title: "",
            contentOne: "",
            contentTwo: ""
          },
          en: {
            title: "",
            contentOne: "",
            contentTwo: ""
          },
          de: {
            title: "",
            contentOne: "",
            contentTwo: ""
          },
          it: {
            title: "",
            contentOne: "",
            contentTwo: ""
          }
        },
        date: "",
        cover: "",
        gallery: [],
        isMediaNews: false
      },
      selectedLanguage: "",
      selectedMainImage: "",
      selectedMainImagePreview: "",
      selectedFiles: [],
      imagesToBeDeleted: [],
      isUrlValid: true,
      isLoading: false,
      isNewsLoaded: false
    };
  },
  methods: {
    handleFileUpload() {
      if (this.$refs.cover.files.length < 2) {
        if (this.$refs.cover.files[0].name.match(/\.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/)) {
          this.selectedMainImagePreview = URL.createObjectURL(
            this.$refs.cover.files[0]
          );
          this.selectedMainImage = this.$refs.cover.files[0].name;
        } else {
          alert("Може да качвате само изображения - .jpg, .jpeg, .png, .gif");
        }
      } else {
        alert("Може да качите само една основна снимка!");
      }
    },
    handleGalleryUpload() {
      if (this.$refs.gallery.files.length < 11) {
        this.selectedFiles = [];
        const filesArray = Array.from(this.$refs.gallery.files);
        for (let i = 0; i < filesArray.length; i++) {
          if (!filesArray[i].name.match(/\.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/)) {
            this.selectedFiles = [];
            this.$refs.gallery.value = "";
            alert(
              "Един или повече файлове са с в непозволен формат! Може да качвате само изображения - .jpg, .jpeg, .png, .gif"
            );
            break;
          }
          this.selectedFiles.push(URL.createObjectURL(filesArray[i]));
        }
      } else {
        alert("Може да качите до 10 снимки в галерията!");
      }
    },
    postNews() {
      if (this.isValid()) {
        this.isLoading = true;
        let data = new FormData();

        data.append("data", JSON.stringify(this.newsObject));

        if (this.selectedMainImage) {
          data.append("cover", this.$refs.cover.files[0]);
        }

        if (this.selectedFiles.length) {
          for (let i = 0; i < this.$refs.gallery.files.length; i++) {
            data.append(`gallery`, this.$refs.gallery.files[i]);
          }
        }

        let requestUrl = `${process.env.ROOT_API}/news`;
        if (this.isEditing) {
          requestUrl = `${process.env.ROOT_API}/news/update/${this.url}`;
          data.append(
            "imagesToBeDeleted",
            JSON.stringify(this.imagesToBeDeleted)
          );
        }
        if (
          this.isEditing &&
          !this.selectedMainImage &&
          !this.selectedFiles.length
        ) {
          requestUrl = `${process.env.ROOT_API}/news/updateTexts/${this.url}`;
        }

        this.$http
          .post(requestUrl, data, {
            headers: {
              "Content-Type": "multipart/form-data",
              path: this.newsObject.url
            }
          })
          .then(res => {
            this.isLoading = false;
            this.$eventHub.$emit("close-create-news");
          })
          .catch(err => {
            this.isLoading = false;
            console.log(err);
          });
      }
    },
    formatDate(event) {
      event.target.value = event.target.value
        .replace(/[^0-9-]/g, "")
        .substr(0, 10);
    },
    createNewDateFromString(event) {
      const t = event.target.value.match(/^(\d{2})\-(\d{2})\-(\d{4})$/);
      if (t !== null) {
        const d = +t[1];
        const m = +t[2];
        const y = +t[3];
        const date = new Date(y, m - 1, d);
        if (date.getFullYear() === y && date.getMonth() === m - 1) {
          // return date;
          this.newsObject.date = date;
        }
      }
    },
    formatUrl() {
      this.newsObject.url = this.newsObject.url
        .replace(/[^A-Za-z0-9-]/g, "")
        .toLowerCase();
    },
    isUrlUnique() {
      this.$http
        .post(`${process.env.ROOT_API}/news/validate-url`, {
          url: this.newsObject.url
        })
        .then(res => {
          this.isUrlValid = res.data.valid;
        })
        .catch(err => {
          console.log(err);
        });
    },
    isContentValid() {
      let titleCounter = 0;
      for (let key in this.newsObject.content) {
        if (this.newsObject.content[key].title.length) {
          titleCounter += 1;
          if (this.newsObject.content[key].title.length > 70) {
            alert(
              `${key.toUpperCase()} - Заглавието, което сте въвели е по-дълго от 70 символа`
            );
            return false;
          }
        }
      }
      // not a single title
      if (!titleCounter) {
        return false;
      }
      return true;
    },
    isValid() {
      if (this.isEditing) {
        if (!this.newsObject.cover && !this.selectedMainImage) {
          return false;
        }
      } else {
        if (!this.selectedMainImage) {
          return false;
        }
        if (!this.isUrlValid || !this.newsObject.url.length) {
          return false;
        }
      }
      if (!this.isContentValid()) {
        return false;
      }
      return true;
    },
    removeCover() {
      this.imagesToBeDeleted.push(this.newsObject.cover);
      this.newsObject.cover = "";
    },
    removeGallery() {
      for (let i = 0; i < this.newsObject.gallery.length; i++) {
        this.imagesToBeDeleted.push(this.newsObject.gallery[i]);
      }
      this.newsObject.gallery = [];
    },
    // EDITING
    findNews() {
      this.$http
        .get(`${process.env.ROOT_API}/news/${this.url}`)
        .then(response => {
          this.newsObject = response.data.news[0];
          this.selectedLanguage = "en";
          this.isNewsLoaded = true;
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    closeModal() {
      this.$eventHub.$emit("close-create-news");
    }
  },
  mounted() {
    this.newsObject.isMediaNews = this.isMedia;
    if (this.isEditing) {
      this.findNews();
    } else {
      this.selectedLanguage = "en";
    }
  }
};
</script>

<style scoped>
.administration-create-news-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}
.administration-create-news {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.05);
  height: 90vh;
  overflow: hidden;
  padding: 80px 30px 30px;
  position: relative;
  width: 1200px;
}
.administration-create-news-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 80px;
  left: 0;
  padding: 0 30px;
  position: absolute;
  top: 0;
  width: 100%;
}
.administration-news-form-submit,
.administration-news-close {
  align-items: center;
  background-color: rgb(0, 156, 244);
  border: none;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 16px;
  justify-content: center;
  margin-left: 6px;
  padding: 10px 20px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.administration-news-form-submit > span {
  color: #fff;
}
.administration-news-form-submit:hover {
  background-color: rgba(0, 156, 244, 0.8);
}
.administration-news-form-submit-invalid {
  opacity: 0.2;
}
.administration-news-close {
  background-color: rgb(64, 64, 64);
}
.administration-news-close:hover {
  background-color: rgba(64, 64, 64, 0.9);
}
.administration-news-form-submit:disabled {
  cursor: default;
  background-color: #f3f3f3;
}
.administration-news-form-submit:disabled:hover {
  background-color: #f3f3f3;
}
.administration-news-form {
  /* align-items: flex-start; */
  /* display: flex; */
  /* flex-direction: column; */
  height: 100%;
  overflow: auto;
}
.administration-news-form-input,
.administration-news-form-textarea {
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #000;
  height: 40px;
  margin: 5px 0;
  padding: 0 15px;
  resize: none;
  width: 100%;
}
.administration-news-form-input:disabled {
  background-color: #f5f5f5;
}
.administration-news-form-textarea {
  height: 200px;
  padding: 15px;
}
.news-url-input {
  align-items: center;
  display: flex;
}
.news-url-input span {
  align-items: center;
  background-color: transparent;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-right: none;
  display: flex;
  height: 40px;
  justify-content: center;
  min-width: 160px;
  padding: 0 15px;
}
.news-url-input input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.upload-file,
.news-images-preview {
  align-items: center;
  background-color: #fff;
  /* border: 1px solid rgba(112, 112, 112, 0.09); */
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  height: 60px;
  justify-content: space-between;
  margin: 10px 0;
  width: 100%;
}
.news-images-preview {
  cursor: default;
}
.gallery-input-wrapper .upload-file {
  width: 100%;
}
.upload-file:hover {
  background-color: #f9f9f9;
}
.upload-file-left {
  align-items: center;
  display: flex;
}
.upload-file-left img {
  height: 40px;
  margin: 0 5px;
  width: 40px;
}
.upload-preview {
  background-position: center;
  background-size: cover;
  border-radius: 6px;
  height: 40px;
  margin: 0 5px;
  width: 40px;
}
.upload-file-left-texts {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
.upload-file-left p {
  color: #002e73;
  font-size: 16px;
}
.upload-file-left span {
  color: #989898;
  font-size: 12px;
}
.upload-file-right {
  align-items: center;
  display: flex;
}
.upload-file-right p {
  align-items: center;
  color: #002e73;
  display: flex;
  font-size: 14px;
  font-weight: 600;
}
.upload-file-right span {
  color: #002e73;
  display: inline-block;
  font-size: 18px;
  margin: 0 13px 0 10px;
}
.folder-svg {
  fill: #002e73;
  height: 20px;
  margin: 0 13px 0 10px;
  width: 20px;
}
.gallery-files-preview {
  display: flex;
}
.input-hide {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.delete {
  cursor: pointer;
  display: flex;
  height: 20px;
  width: 20px;
}
.trash {
  width: 100%;
}
.delete .trash path {
  fill: #d1d4da;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
}
.delete:hover .trash path {
  fill: #e26e6e;
}
.news-type {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.news-type p {
  margin-right: 15px;
}
.news-type span {
  margin: 0 10px;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  cursor: pointer;
  display: inline-block;
  /* font-size: 14px; */
  line-height: 20px;
  padding-left: 28px;
  position: relative;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #004787;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
/* NEWS CONTENT */
.news-content-wrapper {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  width: 100%;
}
.news-content-header {
  display: flex;
  height: 50px;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: -1px;
}
.news-content-toggle-lang-wrapper {
  display: flex;
}
.news-content-toggle-lang {
  align-items: center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 50px;
}
.news-content-toggle-lang-active {
  background-color: #f5f5f5;
}
.news-content-toggle-lang:hover {
  background-color: #f5f5f5;
}
.news-content {
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 20px;
}
.news-input-wrapper {
  margin-bottom: 15px;
  position: relative;
}
.news-input-wrapper-row {
  display: flex;
}
.news-input-mini-wrapper {
  display: flex;
  flex-direction: column;
}
.news-input-mini-wrapper:last-child {
  width: 70%;
}
.news-input-mini-wrapper:first-child {
  width: calc(30% - 20px);
  margin-right: 20px;
}
.news-input-wrapper:last-of-type {
  margin-bottom: 0;
}
.title-counter {
  opacity: 0.4;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
}
.title-counter-invalid {
  color: #e26e6e;
  opacity: 1;
}
.quill-editor-wrapper {
  background-color: #fff;
  border-radius: 6px;
  margin-top: 10px;
  overflow: hidden;
  width: 100%;
}
.component-buttons {
  padding-bottom: 30px;
}
.gallery-position-text {
  color: #989898;
  font-style: italic;
  text-align: center;
}
.not-valid {
  border-color: #e26e6e;
}
.fade-enter-active,
.fade-leave-active {
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/administration/NewsModal.vue